import { Module } from "@com.mgmtp.a12.client/client-core/lib/core/application";

import { loadAppModels } from "./sagas/loadAppModel";

/**
 * Client Module zum Laden der App-Modelle vom Server.
 * TODO: Definition welche Modelle geladen werden soll,
 * fehlt noch.
 */
const appmodelModule = (): Module => ({
	id: "AppModelModule",
	sagas: () => [loadAppModels]
});

export default appmodelModule;
